import pagination from './pagination'

import templates from './templates'
import users from './users'
import accounts from './accounts'
import emailGroups from './email-groups'
import emails from './emails'
import messages from './messages'

// import SmartTable from 'vue-smart-table'
import FileUpload from 'vue-upload-component'

export default {
  install (Vue) {
    // Vue.component('smart-table', SmartTable)
    Vue.component('file-upload', FileUpload)

    const modules = [
      pagination, users, templates, accounts, emailGroups, emails, messages
    ]

    modules.map((m) => {
      m.install(Vue)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js